import { useEffect, useRef } from "react";
import { Card, CardContent } from "../components/ui/card"; // Peut être retiré si tu n’en as plus besoin

export default function AdInCard({ keyId, width, height }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const iframe = document.createElement("iframe");
    iframe.width = width;
    iframe.height = height;
    iframe.style.border = "none";
    iframe.style.overflow = "hidden";
    iframe.setAttribute("scrolling", "no"); // plus fiable que iframe.scrolling
    iframe.setAttribute("frameBorder", "0");

    if (containerRef.current) {
      containerRef.current.innerHTML = "";
      containerRef.current.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow.document;
      const adHTML = `
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              html, body {
                margin: 0;
                padding: 0;
                overflow: hidden;
              }
            </style>
          </head>
          <body>
            <script>
              atOptions = {
                'key': '${keyId}',
                'format': 'iframe',
                'height': ${height},
                'width': ${width},
                'params': {}
              };
            </script>
            <script src="//spendharassingwarmly.com/${keyId}/invoke.js"></script>
          </body>
        </html>
      `;
      doc.open();
      doc.write(adHTML);
      doc.close();
    } 
  }, [keyId, width, height]);

  return (
<Card className="bg-transparent border-0 my-6 mx-4 sm:mx-6">
    <CardContent className="py-4">
      <div className="w-full flex justify-center">
        <div className="w-full flex justify-center my-4" style={{ width: `${width}px`, height: `${height}px` }}>
          <div ref={containerRef} style={{ width: `${width}px`, height: `${height}px` }} />
        </div>
      </div>
    </CardContent>
    </Card>
  );
}
